export default __webpack_public_path__ + "static/media/redoubt.28f49426.png";